export default __webpack_public_path__ + "static/media/SOUPS-BNB.24eeb141.svg";